import { attachAuthInterceptors } from '@repo/auth/axios';
import axios from 'axios';

import { authClient } from 'src/app/auth/auth-client';
import { getLocale } from 'src/packages/language/utils';

const agent = axios.create({
  headers: {
    'content-type': 'application/json',
  },
});

attachAuthInterceptors(agent, authClient);

agent.interceptors.request.use((config) => {
  config.headers['accept-language'] ??= getLocale();
  return config;
});

export { agent as notificationsServiceAgent };
